import React from 'react';
import { EMPTY_OBJECT } from 'constants/app.constants';

const OPAPoliciesContext = React.createContext(EMPTY_OBJECT);

export default OPAPoliciesContext;